/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Mzs_Bachelor11Inputs */

const en__field_enum_mzs_bachelor11 = /** @type {(inputs: _Field_Enum_Mzs_Bachelor11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bachelor`)
};

const de__field_enum_mzs_bachelor11 = /** @type {(inputs: _Field_Enum_Mzs_Bachelor11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bachelor`)
};

/**
* | output |
* | --- |
* | "Bachelor" |
*
* @param {_Field_Enum_Mzs_Bachelor11Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_mzs_bachelor11 = /** @type {((inputs?: _Field_Enum_Mzs_Bachelor11Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Mzs_Bachelor11Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_mzs_bachelor11(inputs)
	return de__field_enum_mzs_bachelor11(inputs)
});
export { _field_enum_mzs_bachelor11 as "_field_enum_MZS_BACHELOR" }